export class UpdateReasons {
    pcnNumber: string;
    reasonIds: Array<number>; 
}